angular.module('samcart')
    .config(['$locationProvider', '$interpolateProvider', function($locationProvider, $interpolateProvider) {

        $interpolateProvider.startSymbol('[[');
        $interpolateProvider.endSymbol(']]');

    }]);
